import React from "react"
import AppBar from "@material-ui/core/AppBar"
import classNames from "classnames"
import HelpOutline from "@material-ui/icons/HelpOutline"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"

import Menu from "../organism/menu"
import texts from "../utils/texts"
import WiezmannLogo from "../assets/logo_weizmann.png"
import WiezmannLogo2X from "../assets/logo_weizmann@2x.png"
import { Desktop, Mobile } from  "../components/device"
import { mobile, desktop } from "../utils/media_queries"
import { makeStyles } from "@material-ui/styles"
import { useReduxState } from "../hooks/use_redux_state"
import CohortLogo from "./cohort_logo"
import AppLogo from "./app_logo"


const useClasses = makeStyles({
  header: {
    width: "100%",
    backgroundColor: "#fff",
    boxShadow: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    [desktop]:{ padding: "10px 70px", },
  },
  logos: {
    display: "flex",
    alignItems: "center",
    gap: "25px",
    fontSize: 0,
    [mobile]: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }
  },
  cohortLogo : {
    maxHeight : "40px",
    maxWidth: "40x",
    margin: "0 10px",
    [mobile]: { maxHeight: "30px", },
  },
  logo: {
    [desktop]: { height: 32, },
    [mobile]: { height: 25, },
  },
  helpLink:{
    fontSize: "18px",
    color: "#57e6ed", 
    fontWeight: "700",
    textDecoration: "none",
    display: "flex",
    "&:visited":{ color: "#bbb", },
    "&:hover span": { textDecoration: "underline", },
    "& svg": { marginRight: 10, },
  },
  separator: {
    height: "16px",
    width: "1px",
    marginLeft: "16px",
    marginRight: "16px",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  user:{
    fontSize: "18px",
    color: "#bbb",
    fontWeight: "700",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }
})


const AppHeader = () => {

  const classes = useClasses()
  const auth = useSelector(state => state.auth)
  const user = `${auth?.user?.firstName} ${auth?.user?.lastName}`
  const [cohort] = useReduxState({ key: "signupCohort" })

  return (
    <AppBar
      position="static"
      className={classNames(classes.header)}
      color="default"
    >
      <div className={classes.logos}>
        <Desktop>
          <Link to="/">
            <AppLogo className={classes.logo} />
          </Link>
          <Link to="/">
            <img
              src={WiezmannLogo} 
              srcSet={`${WiezmannLogo} 1x, ${WiezmannLogo2X} 2x`}
              alt="Logo"
            />
          </Link>
        </Desktop>
        <Mobile>
          <AppLogo className={classes.logo} />
          {cohort && <CohortLogo cohort={cohort} className={classes.cohortLogo} />}
        </Mobile>
      </div>
      <Desktop>
        {cohort && <CohortLogo cohort={cohort} className={classes.cohortLogo} />}
      </Desktop>
      <div className={classes.buttonsContainer}>
        <Desktop>
          <a 
            rel="noopener noreferrer" 
            target="_blank" 
            href="https://support.project10k.org.il"
            className={classes.helpLink}>
            <HelpOutline className={classes.helpIcon} />
            <span>{texts.help}</span>
          </a>
          <div className={classes.separator}/>
          {auth && <span className={classes.user}>{user}</span> }
          {!auth && <span className={classes.user}>{texts.menu}</span> }
        </Desktop>
        <Menu />
      </div>
    </AppBar>
  )
}

AppHeader.propTypes = {}

AppHeader.defaultProps = {}

export default AppHeader
